function customCameraWidget(Survey) {
    let clickedQues = null;
    const imageUploaderWidget = {
        name: 'imageuploader',
        title: 'Image Uploader',
        iconName: 'icon-imagepicker',
        isCopied: true,
        widgetIsLoaded: () => true,
        isFit: (question) => question.getType() === 'imageuploader',
        activatedByChanged: (activatedBy) => {
            Survey.JsonObject.metaData.addClass('imageuploader', [], null, 'empty');

            Survey.JsonObject.metaData.addProperties('imageuploader', [
                { name: '!allowGallery', default: 'camera', choices: [{ value: 'camera', text: 'Camera' }, { value: 'gallery', text: 'Gallery' }, { value: 'both', text: 'Both' }] },
                { name: 'sampleImage', default: '' },
                { name: 'numImages', default: 1 },
                { name: 'camOrientation', default: 'Portrait' },
                { name: 'tagChoices', default: '' },
                { name: '!mediaType', default: 'Photo', choices: [{ value: 'Photo', text: 'Photo Card' }, { value: 'Video', text: 'Video Card' }] }
                // cam orientation...
            ]);
        },

        isDefaultRender: false,
        htmlTemplate: `<div class="customDiv" style="width:100%;">
        <i class="sample-image-icon fa fa-camera fa-2x" style="margin-top:14px;"></i>
        <div class="innerSampleImageDiv">
            <div class="sampleImgDiv" style="max-height:200px;margin-right:18px;display:inline-block;">
                <img src="" class="customImgCss">
                <div style="width:100%;"></div>
            </div>
        </div>
    </div>`,

        // The main function, rendering and two-way binding
        afterRender: (question, el) => {
            const parentEle = el.parentElement;
            let imgIndex = 1;

            parentEle.setAttribute('id', question.id);
            const action = question.numImages ? 'add' : 'replace';

            // const newImageDiv = el.getElementsByClassName('innerSampleImageDiv')[0];
            // newImageDiv.addClass(question.field + '_imgwrap');
            // $('.' + question.field + '_imgwrap').children('.sampleImgDiv').children('img').attr('src', question.sampleImage);

            // const clickIcon = el.getElementsByClassName('sample-image-icon')[0];
            const innerImage = $(el).find('.innerSampleImageDiv');
            innerImage.css({'display': 'flex'});
            // newImageDiv.addClass(question.field + '_imgwrap');
            // $('.' + question.field + '_imgwrap').children('.sampleImgDiv').children('img').attr('src', question.sampleImage);

            const clickIcon = el.getElementsByClassName('sample-image-icon')[0];
            const image = el.getElementsByClassName('customImgCss')[0];
            let imgUrl = ''
            if(question.value) {
                $(el).find('.fa-camera').hide();
                if(Array.isArray(question.value)) {
                    for(let img of question.value) {
                        var $div = $('<div>').addClass('uploadedImageWithDel');

                        var $img = $('<img>').attr({
                                    'src': img.url,
                                    'class': 'customImgCss'
                                    });
                        $div.css({'margin-right': '10px'});
    
                        $div.append($img);
    
                        innerImage.append($div);
                    }
                }
            }

            // clickIcon.onclick = () => {
            //     const url = question.sampleImage;
            //     if (action === 'add') {
            //         const imgUploaded = newImageDiv.getElementsByClassName('uploadedImageWithDel').length + 1;
            //         // const imgUploaded = $('.' + question.field + '_imgwrap').children('.uploadedImageWithDel').length + 1;
            //         if (question.numImages > 0 && imgUploaded >= question.numImages) {
            //             el.getElementsByClassName('fa-camera')[0].hide();
            //         }
            //         clickedQues = question;
            //         imgIndex = imgIndex + 1;
            //     } else {
            //         clickedQues = question;
            //     }
            // };
        },
    };
    Survey.CustomWidgetCollection.Instance.addCustomWidget(imageUploaderWidget, 'customtype');
}